import { render } from "./IconDashboard.vue?vue&type=template&id=7dfe02e6"
import script from "./IconDashboard.vue?vue&type=script&lang=js"
export * from "./IconDashboard.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/icons/IconDashboard.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "7dfe02e6"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('7dfe02e6', __exports__)) {
    api.reload('7dfe02e6', __exports__)
  }
  
  module.hot.accept("./IconDashboard.vue?vue&type=template&id=7dfe02e6", () => {
    api.rerender('7dfe02e6', render)
  })

}


export default __exports__